import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link/Link';

const trackEvent = {
  eventType: 'Click Main Navigation',
  properties: {
    navigation_core: 'Home',
  },
};

const Logo = ({ children, link, linkDataId, linkStyle }) => {
  if (children) {
    return (
      <Link
        dataId={linkDataId}
        to={link}
        className={linkStyle}
        trackEvent={{ ...trackEvent, properties: { navigation_core: 'Home' } }}
      >
        {children}
      </Link>
    );
  }
  return null;
};

Logo.propTypes = {
  children: PropTypes.node,
  link: PropTypes.string,
  linkDataId: PropTypes.string,
  linkStyle: PropTypes.string,
};

Logo.defaultProps = {
  children: null,
  link: null,
  linkDataId: null,
  linkStyle: 'black flex items-center',
};

export default Logo;
